'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var INITIALIZE_DATALAYER = exports.INITIALIZE_DATALAYER = 'window.dataLayer = window.dataLayer || [];';

var INITIALIZE_INHOUSE_ANALYTICS = exports.INITIALIZE_INHOUSE_ANALYTICS = 'window.__inhouseSend__ = window.__inhouseSend__ || function(body) {\n  window.fetch(\'/marketplace/graphql\', { method: \'POST\',  headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });\n};';

exports.default = {
  INITIALIZE_DATALAYER: INITIALIZE_DATALAYER
};
//# sourceMappingURL=constants.js.map